const MessageText = ({ text }) => {
    return (
        <div style={{ height: "90vh", fontSize: "5rem"}} className="text-center pt-5">
            {text}
        </div>
    );
};

export default MessageText